import React from 'react';
import { useNavigate } from 'react-router-dom';
import PaginatedTable from '../components/PaginatedTable';
import { httpRequest } from '../services/httpService';
import { Grid, IconButton, Link, TableCell, TableRow, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchField from '../components/SearchField';
import {useSnackbar} from "../contexts/SnackbarContext";
import { EmptyGuid } from '../utils/constants';

export default function Clients() {
    const navigate = useNavigate();
    const showSnackbar = useSnackbar();

    const fetchClients = async (page, rowsPerPage, search) => {
        const skip = page * rowsPerPage;
        const take = rowsPerPage;
        const response = await httpRequest('/api/client/list', { params: { skip, take, search } }, showSnackbar);
        return { data: response.data, totalCount: response.totalItems };
    };

    const renderClientRow = (client, onRowClick) => (
        <TableRow
            key={client.id}
            hover
            style={{ cursor: 'pointer' }}
            onClick={() => onRowClick(client)}
        >
            <TableCell>{client.fullName}</TableCell>
            <TableCell>
                <Link
                    href={`mailto:${client.email}`}
                    onClick={(event) => event.stopPropagation()}
                >
                    {client.email}
                </Link>
            </TableCell>
            <TableCell>{client.phone}</TableCell>
            <TableCell>{client.documentNumber}</TableCell>
        </TableRow>
    );

    const handleRowClick = (client) => {
        navigate(`/clients/${client.id}`);
    };

    return (
        <PaginatedTable
            fetchData={fetchClients}
            headers={['Nombre', 'Correo', 'Teléfono', 'DNI']}
            renderRow={renderClientRow}
            onRowClick={handleRowClick}
            toolbar={
                <Grid
                    container
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                    }}
                >
                    <Grid sx={{ display: 'flex', alignItems: 'center', padding: 1 }}>
                        <Typography variant="h5">Clientes</Typography>                        <IconButton color="primary" onClick={() => handleRowClick({ id: EmptyGuid })}>
                            <AddIcon />
                        </IconButton>
                    </Grid>
                    <Grid sm={6} md={6} lg={4} sx={{ mr: 2 }}>
                        <SearchField />
                    </Grid>
                </Grid>
            }
        />
    );
}